import _ from "underscore";
import BasicUtils from "./basic-utils";
var MODAL_KEY = "modal";
var _overlays = [];
var _callbacks = [];

var _runCallbacks = function _runCallbacks() {
  return _.each(_callbacks, function (cb) {
    return cb();
  });
};

export var actions = {
  overlay: function overlay(component) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var overlays = _.clone(_overlays);

    var selected = _.findWhere(overlays, {
      key: properties.key
    });

    if (selected) {
      _.extend(selected, {
        component: component,
        position: properties
      });
    } else {
      overlays.push({
        component: component,
        position: properties,
        key: properties.key || BasicUtils.randomKey()
      });
    }

    _overlays = overlays;
    return _runCallbacks();
  },
  removeOverlay: function removeOverlay(key) {
    _overlays = _.filter(_overlays, function (overlay) {
      if (_.isUndefined(key)) {
        return false;
      }

      return overlay.key !== key;
    });
    return _runCallbacks();
  },
  launchModal: function launchModal(component) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MODAL_KEY;

    var props = _.extend({}, {
      key: key,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 9999
    });

    this.overlay(component, props);
  },
  removeModal: function removeModal() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODAL_KEY;
    this.removeOverlay(key);
  }
};
export var store = {
  getAll: function getAll() {
    return _.clone(_overlays);
  },
  onChange: function onChange(callback) {
    return _callbacks.push(callback);
  },
  clearOnChange: function clearOnChange(callback) {
    return _callbacks = _.without(_callbacks, callback);
  }
};